export default {
    address: {
        city: "City",
        city_locality: "City / Locality",
        country: "Country",
        line1: "Address Line 1",
        line2: "Address Line 2",
        postal_code: "Postal Code",
        state: "State",
        state_region: "State / Region",
    },
    alerts: {
        account_2fa: "Secure your account with two-factor authentication.",
        account_2fa_success: "Two-factor authentication is enabled.",
        activate_instruction: "Turning on automatic review collection will attempt to request a review from {count}. View your templates before enabling.",
        activate_intro: "Continuously request reviews based on your strategy.",
        agency_mcp_server: "Connect Claude or any MCP client to your agency MCP server. Authorized assistants can manage your agency’s projects, clients, and team on your behalf.",
        agency_sso: "Connect an OpenID Connect identity provider for client login.",
        ai_assistant: "Your business name and description are required to use AI for review suggestions and replies.",
        api_key_roll: "Are you sure you want to change your API key? This will impact any application that is using it.",
        ask_confirm: "Are you sure you want to request reviews from {count}? This will schedule requests for all customers that have not been asked yet.",
        cname_delete: "Are you sure you want to remove the CNAME: {cname_name}?",
        cname_not_configured: "This record has not yet been configured. Please wait...",
        cname_warning: "Messages that have already been sent to your customers will have broken links.",
        connection_disabled: "Connection is disabled. Please reconnect.",
        customer_archive: "Are you sure you want to archive the customer: {customer_name}? Any unsent messages will be canceled.",
        customer_cancel: "Are you sure you want to cancel all unsent messages for customer: {customer_name}?",
        customer_ingest: "Include this email address in the BCC field when sending emails to your customers to have their name and email address imported automatically.",
        customer_resubscribe: "Are you sure you want to resubscribe the customer: {customer_name}?",
        customer_unarchive: "Are you sure you want to unarchive the customer: {customer_name}?",
        customer_unsubscribe: "Are you sure you want to unsubscribe the customer: {customer_name}?",
        customer_unsubscribe_all: "Are you sure you want to unsubscribe {count} from receiving messages from this project?",
        delete: "Are you sure you want to delete the {model}: {name}?",
        delete_count: "Are you sure you want to delete {count}",
        domain_agency: "Add your own sending domain to fully white label your agency.",
        domain_delete: "Are you sure you want to remove the domain: {name}? We will continue to send emails from our own domain name.",
        domain_dmarc: "Add a DMARC record to your domain to reduce the chance of emails going to spam.",
        domain_project: "Add a sending domain so we can send emails to your customers from your own domain name.",
        export_confirm: "Are you sure you want to export all of your {model}?",
        export_count: "Are you sure you want to export {count}?",
        export_link: "A download link will be sent to {email} shortly after you make the request.",
        highlights_save_disabled: "You can optionally remove highlights from all reviews that currently have them.",
        highlights_save_enabled: "To generate highlights for all positive reviews, check the box below. If you are only changing the highlight color, leave the box unchecked.",
        integration_disconnect: "Are you sure you want to disconnect from {integration_name}?",
        integration_sync: "Are you sure you want to sync your {integration_name} account? We’ll continuously import your data for you.",
        intro: "Ready to get more good reviews from your customers? Import your customers to get started. Then request reviews manually or press the Automate button and let the reviews roll in.",
        logout: "Are you sure you want to log out?",
        mcp_server: "Connect Claude or any MCP client to this project. The MCP server lets AI assistants read and manage reviews, customers, and messages on your behalf.",
        member_confirm: "Are you sure you want to remove yourself? You will lose access to this project.",
        member_confirm_all: "Are you sure you want to remove yourself? You will lose access to all of your projects.",
        member_other_confirm: "Are you sure you want to remove the {noun}: {name}? They will lose access to this project.",
        member_other_confirm_all: "Are you sure you want to remove the {noun} {name}? They will lose access to all of their projects.",
        message_cancel: "Are you sure you want to cancel this message?",
        message_cancel_all: "Are you sure you want to cancel {count}? This action can only be performed on unsent messages.",
        message_delete: "Are you sure you want to delete this message?",
        oauth_client_revoke: "Are you sure you want to revoke access for {client}? Any active sessions will be disconnected immediately.",
        project_summary: "Unable to generate a summary at this time.",
        project_suspend: "Are you sure you want to suspend the project: {project_name}?",
        project_unsuspend: "Are you sure you want to unsuspend the project: {project_name}?",
        review_delete: "Are you sure you want to delete this review? This action cannot be undone.",
        review_page_confirm: "Are you sure you want to save your changes?",
        review_page_default: "Are you sure you want to make the review page: {name} your default page? This page will be used if no other page is assigned to a review request.",
        review_page_delete: "Are you sure you want to delete the review page: {name}? All customers that are currently directed to this page will be directed to your default page.",
        review_page_delete_all: "Are you sure you want to delete {count}? Your default review page will not be deleted.",
        review_page_fields: "Use fields to capture customer info when leaving a review. Add more fields to your form and conditionally display them when customers select a rating.",
        review_page_instructions: "Show instructions directly above the form after a rating is selected.",
        review_page_location_picker: "Let customers select any location in your project for the review. This will be pre-selected if the review page is intended to be shown for a specific location.",
        review_page_locations: "Select the locations that should use this review page. A location can only be assigned to one review page. If a location is not assigned one, it will use the default review page.",
        review_page_redirects: "Skip the form after a rating is selected and redirect elsewhere. You can also split the traffic to multiple websites by adding more than one redirect for each rating.",
        share_template_delete: "Are you sure you want to delete the share template \"{name}\"? This cannot be undone.",
        smtp_remove: "Are you sure you want to remove the SMTP configuration from your project? Your sending domain will fall back to the standard configuration.",
        smtp_setup: "Send emails from your own mail server. Enter your SMTP credentials. If your server uses IP restrictions, please whitelist the following IPs used by our system: {ips}.",
        space_delete: "Are you sure you want to delete the space: {name}? All projects inside of it will be deleted.",
        tag_rule: "Add a positive term and its negative counterpart. If it applies, we will use AI to automatically tag the review with one or the other.",
        user_delete: "Are you sure you want to delete the user account for: {email}?",
        user_verify: "To verify your email address and activate your account, click the link in the email sent to: {email}.",
        widget_delete: "Are you sure you want to delete the widget: {name}? The widget will no longer be displayed on any websites.",
        widget_restore: "Are you sure you want to restore the settings for widget: {name}? Only the design will revert back to default values.",
        widgets_1: "Add this script to the body of your website.",
        widgets_2: "The Review Wall showcases all your reviews as a grid. Add this script wherever you want the widget to be displayed.",
        widgets_3: "The Review Spotlight showcases one large review. Add this script wherever you want the widget to be displayed.",
    },
    billing_statuses: {
        active: "Your subscription is active.",
        canceled: "Your subscription is canceled. Please upgrade to continue.",
        ending: "Your subscription ends on {date}.",
        trial: "Your free trial ends on {date}.",
        trial_expired: "Your free trial has ended. Please upgrade to continue.",
        trial_expiring: "Your free trial is ending soon. Please upgrade to continue.",
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "Email",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier",
    },
    captions: {
        add_sending_domain: "Add a sending domain to edit your email address:",
        agency_robots: "Allow search engines to index your customer portal.",
        ai_business_description: "A detailed description of your business to aid in generating review suggestions and replies.",
        ai_business_name: "The name of your business.",
        ask_location: "The location to assign to the review.",
        ask_review_page: "The page to capture the review.",
        assign_tags: "Assign tags to the review.",
        csv_max_rows: "Up to {count} Rows",
        dashboard_configure_settings: "Configure your project settings.",
        dashboard_import_customers: "Import your customers.",
        dashboard_preview_email_templates: "Preview your email templates.",
        dashboard_preview_kiosk_page: "Preview your kiosk page.",
        dashboard_preview_review_page: "Preview your review page.",
        dashboard_preview_showcase_page: "Preview your showcase page.",
        logo_height: "The height of the logo on emails and pages.",
        meta_description: "Override the page description.",
        meta_title: "Override the page title.",
        mfa_password: "Enter your account password.",
        mfa_qr_code: "Scan the QR code with your authenticator app.",
        mfa_security_code: "Enter the code from your authenticator app.",
        override_ambassador: "Display a badge on your clients’ emails, pages, and widgets.",
        project_name: "The name of your business, brand, or website.",
        project_robots: "Allow search engines to index your review pages and showcase.",
        setup_basics: "Set when and how you ask customers for reviews.",
        setup_business: "Tell us the name customers know you by.",
        setup_google: "Send customers to your Google profile, reply to reviews, and import existing ones. You can skip this and do it later.",
        setup_location_limit: "Your trial includes 1 location. Upgrade anytime to sync more.",
        project_slug: "Used in customer facing emails and links if a CNAME is not configured.",
        review_page_copied_message: "Shown after a positive review has been submitted.",
        review_page_email_address: "Receive reviews at this email.",
        review_page_link_reveal_position: "Where to reveal the links.",
        review_page_link_revealer_label: "The label to reveal the links.",
        review_page_link_revealer_rating: "Reveal links if the customer selects this rating or higher, otherwise show a button to reveal them.",
        review_page_native_reviews: "Allow reviews on this platform.",
        review_page_rating_selection: "Save rating before a review is submitted.",
        review_page_success_button_link: "If blank, the link defaults to your project website, otherwise the domain of the page.",
        review_page_warning: "Preventing customers from leaving public reviews may get your business listing removed.",
        review_reply_status: "We cannot reply publicly to this review. You may contact the reviewer directly instead.",
        review_suggestions: "Help customers write reviews.",
        separate_with_commas: "Separate multiple with commas.",
        showcase_locations: "Limit the showcase to specific locations.",
        showcase_review_length: "Reviews must be at least this many characters.",
        showcase_since: "Show reviews created on or before this date.",
        showcase_sources: "Limit the showcase to specific sources.",
        showcase_tags: "Limit the showcase to reviews with specific tags.",
        signature_html: "Copy and paste the signature into your email application.",
        signed_up: "The customer’s start date.",
        twilio_webhook: "Set as the callback URL for your messaging service.",
        widget_embed: "The ID attribute of the div container where the widget will be displayed.",
    },
    labels: {
        accept_all: "Accept All",
        access_code: "Access Code",
        access_codes: "Access Codes",
        account: "Account",
        account_sid: "Account SID",
        action: "Action",
        actions: "Actions",
        activate: "Activate",
        active: "Active",
        active_subscription: "Active Subscription",
        add: "Add",
        add_agency_project: "Add an Agency Project",
        add_confirmation_message: "Add a confirmation message.",
        add_css_rules: "Add your own css rules.",
        add_custom_field: "Add Custom Field",
        add_customer: "Add a Customer",
        add_customers_with: "Add Customers with {model}",
        add_external_link: "Add an External Link",
        add_external_links: "Add External Links",
        add_introduction: "Add an introduction.",
        add_js_tags: "Add your own JavaScript tags.",
        add_legal_information: "Add legal information.",
        add_location: "Add a Location",
        add_project: "Add a Project",
        add_review: "Add a Review",
        add_source: "Add a Source",
        add_tag: "Add a Tag",
        added: "Added",
        address: "Address",
        advanced_review_pages: "Advanced Review Pages",
        affiliates: "Affiliates",
        age_of_reviews: "Age of Reviews",
        agency: "Agency",
        agency_name: "Agency Name",
        agency_project: "Agency Project",
        agency_projects: "Agency Projects",
        ai: "AI",
        ai_answers: "AI Answers",
        ai_assistant: "AI Assistant",
        ai_auto_tagging: "AI Auto Tagging",
        ai_reviews_and_replies: "AI review suggestions and replies",
        ai_tagging_instructions: "Example: Apply to reviews that mention wait times, slow service, or delays.",
        all: "All",
        allowed_domains: "Allowed Domains",
        amount: "Amount",
        analytics: "Analytics",
        and: "and",
        anonymous_reviews: "Anonymous Reviews",
        answer: "Answer",
        any: "Any",
        api: "API",
        api_key: "API Key",
        appearance: "Appearance",
        approved: "Approved",
        archive: "Archive",
        archive_customer: "Archive Customer",
        archived: "Archived",
        at_least: "at least",
        at_least_days: "At least {num} days",
        at_least_hours: "At least {num} hours",
        at_least_months: "At least {num} months",
        at_most: "at most",
        at_most_days: "At most {num} days",
        at_most_hours: "At most {num} hours",
        at_most_months: "At most {num} months",
        auth_token: "Auth Token",
        authorize: "Authorize",
        auto_detect: "Auto-Detect",
        auto_tags: "Auto-Tags",
        automate: "Automate",
        automate_highlights: "Automate Highlights",
        automate_replies: "Automate Replies",
        automatic_review_collection: "Automatic Review Collection",
        automatically_apply_tags: "Automatically apply tag to existing reviews",
        automating: "Automating",
        avatar: "Avatar",
        avatars: "Avatars",
        average_charge: "Average Charge",
        average_review: "Average Review",
        background_color: "Background Color",
        background_image: "Background Image",
        back: "Back",
        bcc: "BCC",
        bcc_email_address: "BCC Email Address",
        best_to_worst: "Best to worst",
        billing: "Billing",
        blog: "Blog",
        body: "Body",
        body_font_size: "Body Font Size",
        bold: "Bold",
        book_a_demo: "Book a Demo",
        bottom: "Bottom",
        bottom_left: "Bottom Left",
        bottom_right: "Bottom Right",
        build_on: "Build on {model}",
        business: "Business",
        business_description: "Business Description",
        business_email: "Support Email Address",
        business_name: "Business Name",
        business_phone: "Support Phone Number",
        business_website: "Business Website",
        button: "Button",
        button_label: "Label for Button",
        button_link: "Link for Button",
        button_position: "Position of Button",
        button_size: "Size of Button",
        buy_me_a_coffee: "Buy Me a Coffee",
        by: "by",
        by_signing_up: "By creating an account, you agree to our",
        call_to_action: "Call to Action",
        cancel: "Cancel",
        cancel_1_message: "Cancel 1 Message",
        cancel_message: "Cancel Message",
        cancel_messages: "Cancel {count} Messages",
        cancel_subscription: "Cancel Subscription",
        cancel_unsent_messages: "Cancel Unsent Messages",
        canceled: "Canceled",
        center: "Center",
        change: "Change",
        change_key: "Change Your API Key",
        change_plan: "Change Plan",
        changelog: "Changelog",
        channel: "Channel",
        channels: "Channels",
        characters: "Characters",
        charges_avg: "Average charge must be at least",
        charges_count: "Number of charges must be at least",
        charges_sum: "Total charges must be at least",
        chat_with_us: "Chat with Us",
        checkbox: "Checkbox",
        claude: "Claude",
        clear: "Clear",
        clear_highlights_from_reviews: "Remove highlights from all reviews",
        clicked: "Clicked",
        client: "Client",
        client_id: "Client ID",
        clients: "Clients",
        close: "Close",
        cloudflare_warning: "If you use Cloudflare, your proxy must be off.",
        cname: "CNAME",
        cname_setup_incomplete: "Setup incomplete - will be removed on {date}",
        cname_ssl_pending: "Awaiting SSL certificate",
        cname_status_for: "CNAME status for",
        code_editor: "Code Editor",
        collapse: "Collapse",
        collect_reviews_anywhere: "Collect reviews anywhere",
        color: "Color",
        colors: "Colors",
        commission_rate: "Commission Rate",
        commission_status_approved: "Approved",
        commission_status_paid: "Paid",
        commission_status_pending: "Pending",
        commission_status_reversed: "Reversed",
        community: "Community",
        company: "Company",
        complained: "Complained",
        confirm_new_password: "Confirm New Password",
        confirmation_message: "Confirmation Message",
        connect: "Connect",
        connect_bank: "Connect Bank Account",
        connect_google: "Connect Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Connected",
        consent_preferences: "Consent Preferences",
        contact_customer: "Contact Customer",
        contact_support: "Please contact support.",
        contact_us: "Contact Us",
        container_element: "Container Element",
        context: "Context",
        continue: "Continue",
        continue_with_google: "Continue with Google",
        cookie_category_analytics: "Analytics",
        cookie_category_essential: "Essential",
        cookie_category_functional: "Functional",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Cookie Consent Banner",
        cookie_consent_scope_all: "Show to everyone",
        cookie_consent_scope_eea: "Show to EEA & UK visitors only",
        cookie_consent_scope_none: "Do not show",
        cookie_policy: "Cookie Policy",
        cookie_preference: "Cookie Preferences",
        copied: "Copied",
        copied_message: "Copied Message",
        copy: "Copy",
        copy_embed_code: "Copy Embed Code",
        copy_signature: "Copy Signature",
        copy_source_code: "Copy Source Code",
        copy_uuid: "Copy UUID",
        create: "Create",
        create_account: "Create Account",
        create_agency: "Create an Agency",
        create_cname: "Create a CNAME record and point it to",
        create_external_link: "Create an External Link",
        create_field: "Create a Field",
        create_link: "Create a Link",
        create_location: "Create a Location",
        create_project: "Create a Project",
        create_qr_code: "Create QR Code",
        create_review: "Create a Review",
        create_review_page: "Create a Review Page",
        create_signature: "Create a Signature",
        create_source: "Create a Source",
        create_space: "Create a Space",
        create_tag: "Create a Tag",
        create_tag_rule: "Create a Tag Rule",
        create_webhook: "Create a Webhook",
        create_widget: "Create a Widget",
        crms: "CRMs",
        csv: "CSV",
        currency: "Currency",
        current_plan: "Current Plan",
        current_year: "Current Year",
        custom_field: "Custom Field",
        custom_instructions: "Custom Instructions",
        custom_url: "Custom URL",
        customer: "Customer",
        customer_name_convention: "Customer Name Convention",
        customer_reviews: "Customer Reviews",
        customers: "Customers",
        customize: "Customize",
        customize_review_page: "Customize Review Page",
        daily: "Daily",
        daily_email_requests: "Daily Email Requests",
        daily_limit: "Daily Limit",
        daily_requests: "Daily Requests",
        daily_sms_requests: "Daily SMS Requests",
        dark: "Dark",
        dashboard: "Dashboard",
        date: "Date",
        date_added: "Date Added",
        date_canceled: "Date Canceled",
        date_clicked: "Date Clicked",
        date_complained: "Date Complained",
        date_delivered: "Date Delivered",
        date_failed: "Date Failed",
        date_messaged: "Date Messaged",
        date_opened: "Date Opened",
        date_replied: "Date Replied",
        date_requested: "Date Requested",
        date_reviewed: "Date Reviewed",
        date_scheduled: "Date Scheduled",
        date_sent: "Date Sent",
        date_signed_up: "Date Signed Up",
        date_updated: "Date Updated",
        dates: "Dates",
        day: "Day",
        days: "Days",
        days_after_last_request: "days after last request",
        days_later: "days later",
        deactivate: "Deactivate",
        default: "Default",
        default_language: "Default Language",
        default_review_page: "Default Review Page",
        default_review_visibility: "Default Review Visibility",
        default_tone: "Default Tone",
        delay: "Delay",
        delete: "Delete",
        delete_1_customer: "Delete 1 Customer",
        delete_1_review: "Delete 1 Review",
        delete_1_review_page: "Delete 1 Review Page",
        delete_1_widget: "Delete 1 Widget",
        delete_agency: "Delete Agency",
        delete_custom_field: "Delete Custom Field",
        delete_customer: "Delete Customer",
        delete_customers: "Delete Customers",
        delete_external_link: "Delete External Link",
        delete_field: "Delete Field",
        delete_link: "Delete Link",
        delete_location: "Delete Location",
        delete_message: "Delete Message",
        delete_n_customers: "Delete {count} Customers",
        delete_n_review_pages: "Delete {count} Review Pages",
        delete_n_reviews: "Delete {count} Reviews",
        delete_n_widgets: "Delete {count} Widgets",
        delete_project: "Delete Project",
        delete_qr_code: "Delete QR Code",
        delete_reply: "Delete Reply",
        delete_review: "Delete Review",
        delete_review_page: "Delete Review Page",
        delete_review_pages: "Delete Review Pages",
        delete_reviews: "Delete Reviews",
        delete_signature: "Delete Signature",
        delete_source: "Delete Source",
        delete_space: "Delete Space",
        delete_tag: "Delete Tag",
        delete_tag_rule: "Delete Tag Rule",
        delete_template: "Delete Template",
        delete_user: "Delete User",
        delete_webhook: "Delete Webhook",
        delete_widget: "Delete Widget",
        delete_widgets: "Delete Widgets",
        deleted: "Deleted",
        delivered: "Delivered",
        description: "Description",
        deselect_all: "Deselect All",
        disable: "Disable",
        disable_automatic_review_collection: "Disable Automatic Review Collection",
        disable_field: "Disable Field",
        disable_when_links_are_visible: "Disable when links are visible",
        disabled: "Disabled",
        disconnect: "Disconnect",
        disconnect_integration: "Disconnect Integration",
        discord_community: "Discord Community",
        display_name: "Display Name",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC status for",
        do_not_hide_from_public: "Do Not Hide from Public",
        do_not_send: "Do not send",
        documentation: "Documentation",
        domain: "Domain",
        domain_name: "Domain Name",
        dont_have_an_account: "Don’t have an account?",
        dont_send_thanks: "Don’t send thanks",
        download: "Download",
        download_records: "Download Records",
        download_template: "Download Template",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Duplicate",

        duplicate_project: "Duplicate Project",
        duplicate_review_page: "Duplicate Review Page",
        duplicate_reviews: "Duplicate Reviews",
        duplicate_widget: "Duplicate Widget",
        edit: "Edit",
        edit_1_customer: "Edit 1 Customer",
        edit_1_review: "Edit 1 Review",
        edit_client: "Edit Client",
        edit_custom_field: "Edit Custom Field",
        edit_customer: "Edit Customer",
        edit_customers: "Edit Customers",
        edit_field: "Edit Field",
        edit_link: "Edit Link",
        edit_location: "Edit Location",
        edit_member: "Edit Member",
        edit_n_customers: "Edit {count} Customers",
        edit_n_reviews: "Edit {count} Reviews",
        edit_notes: "Edit Notes",
        edit_qr_code: "Edit QR Code",
        edit_reviews: "Edit Reviews",
        edit_signature: "Edit Signature",
        edit_source: "Edit Source",
        edit_strategy: "Edit Strategy",
        edit_tag: "Edit Tag",
        edit_tag_rule: "Edit Tag Rule",
        edit_team_member: "Edit Team Member",
        edit_visibility: "Edit Visibility",
        edit_webhook: "Edit Webhook",
        editable_ratings: "Editable Ratings",
        earned: "Earned",
        eligible: "Eligible",
        email: "Email",
        email_address: "Email Address",
        email_validation_invalid: "Email validation failed",
        email_validation_passed: "Email validation passed",
        email_validation_unknown: "Email could not be verified",
        emails: "Emails",
        embed_code: "Embed Code",
        enable: "Enable",
        enable_automatic_review_collection: "Enable Automatic Review Collection",
        enable_for_all_reviews: "Enable for all reviews",
        enable_for_positive_reviews: "Enable for positive reviews",
        enable_on_review_pages: "Enable on review pages",
        enabled: "Enabled",
        end: "End",
        ends: "Ends",
        exclude: "Exclude",
        exclude_email: "Exclude Email",
        exclude_sms: "Exclude SMS",
        excluded_channels: "Excluded Channels",
        expand: "Expand",
        expired: "Expired",
        export: "Export",
        export_1_customer: "Export 1 Customer",
        export_1_review: "Export 1 Review",
        export_all: "Export All",
        export_all_customers: "Export All Customers",
        export_all_reviews: "Export All Reviews",
        export_customers: "Export Customers",
        export_n_customers: "Export {count} Customers",
        export_n_reviews: "Export {count} Reviews",
        export_reviews: "Export Reviews",
        external_link: "External Link",
        external_links: "External Links",
        extra_locations: "Extra Locations",
        faces: "Faces",
        failed: "Failed",
        feedback: "Feedback",
        field: "Field",
        fields: "Fields",
        filter: "Filter",
        first: "First",
        first_charged: "First Charged",
        first_name: "First Name",
        first_name_last_initial: "First Name, Last Initial",
        flag_as_duplicate: "Flag as Duplicate",
        font: "Font",
        font_family: "Font Family",
        font_size: "Font Size",
        footer: "Footer",
        for: "For",
        forgot_password: "Forgot Password",
        form: "Form",
        free: "Free",
        free_requests_included: "Free requests included",
        from: "from",
        full_name: "Full Name",
        generate: "Generate",
        generate_meta: "Generate Meta",
        generate_qr_code: "Generate QR Code",
        generate_reply: "Generate Reply",
        generate_review: "Generate Review",
        generating: "Generating",
        get_started: "Get Started",
        get_started_checklist: "Get Started Checklist",
        get_the_lifetime_deal: "Get the Lifetime Deal",
        getting_started: "Getting Started",
        google_fonts: "Google Fonts",
        grouped_by_request: "Grouped by Request",
        has_links: "Has Links",
        has_notes: "Has Notes",
        has_redirects: "Has Redirects",
        have_an_account: "Have an account?",
        header: "Header",
        hidden: "Hidden",
        hidden_from_search_engines: "Hidden from Search Engines",
        hidden_reviews: "Hidden Reviews",
        hide: "Hide",
        hide_all_reviews: "Hide all reviews",
        hide_avatar: "Hide Avatar",
        hide_date: "Hide Date",
        hide_drop_shadow: "Hide Drop Shadow",
        hide_field_label: "Hide Field Label",
        hide_from_public: "Hide from Public",
        hide_name: "Hide Name",
        hide_pagination: "Hide Pagination",
        highlight_color: "Highlight color",
        hipaa: "HIPAA",
        host: "Host",

        hours: "Hours",
        icon: "Icon",
        icon_size: "Icon Size",
        icons: "Icons",
        id: "ID",
        image: "Image",
        import: "Import",
        import_address1: "The customer’s address line 1.",
        import_address2: "The customer’s address line 2.",
        import_city: "The customer’s city or locality.",
        import_company: "The customer’s company name.",
        import_created_at: "The date of the review.",
        import_customers: "Import Customers",
        import_email: "The customer’s email address.",
        import_first_name: "The customer’s first name.",
        import_from_boost_space: "Import from Boost.space",
        import_from_facebook: "Import from Facebook",
        import_from_google: "Import from Google",
        import_from_hubspot: "Import from HubSpot",
        import_from_make_com: "Import from Make.com",
        import_from_pabbly: "Import from Pabbly",
        import_from_stripe: "Import from Stripe",
        import_from_zapier: "Import from Zapier",
        import_last_name: "The customer’s last name.",
        import_list: "Comma-separated list of",
        import_notes: "Notes for internal use only.",
        import_phone: "The customer’s phone number.",
        import_postal_code: "The customer’s postal code.",
        import_recent_reviews: "Import Recent Reviews",
        import_review: "The review text.",
        import_reviews: "Import Reviews",
        import_score: "The rating from 1 - 5.",
        import_signed_up_at: "The customer’s start date.",
        import_slug: "The slug or UUID of a",
        import_state: "The customer’s state or region.",
        incentive: "Incentive",
        include: "Include",
        include_sample_reviews: "Include sample reviews",
        incoming_webhook_url: "Incoming Webhook URL",
        inherit: "Inherit",
        initializing: "Initializing",
        initials: "Initials",
        insert_variable: "Insert Variable",
        instructions: "Instructions",
        integration: "Integration",
        integrations: "Integrations",
        interval: "Interval",
        introduction: "Introduction",
        invite: "Invite",
        invite_client: "Invite Client",
        invite_failed: "Invite failed",
        invite_member: "Invite Member",
        invite_sent_to: "Invite Sent To",
        invite_team_member: "Invite Team Member",
        invited: "Invited",
        issuer_url: "Issuer URL",
        italic: "Italic",
        joined: "Joined",
        key: "Key",
        keywords: "Keywords",
        keywords_in_replies: "Keywords in Replies",
        keywords_in_reviews: "Keywords in Reviews",
        kiosk_page: "Kiosk Page",
        label: "Label",
        label_font_size: "Label Font Size",
        labels: "Labels",
        language: "Language",
        languages: "Languages",
        large: "Large",
        last_charged: "Last Charged",
        last_name: "Last Name",
        layout: "Layout",
        leave: "Leave",
        leave_project: "Leave Project",
        leave_space: "Leave Space",
        left: "Left",
        let_clients_sign_in_with_sso: "Let clients sign in with SSO",
        less: "less",
        lifecycle_stage: "Lifecycle Stage",
        lifetime_deal: "Lifetime Deal",
        light: "Light",
        limit: "Limit",
        limits: "Limits",
        link: "Link",
        link_color: "Link Color",
        link_reveal_position: "Link Reveal Position",
        link_revealer_button: "Link Revealer Button",
        link_revealer_label: "Link Revealer Label",
        link_revealer_rating: "Link Revealer Rating",
        links: "Links",
        links_per_review_page: "Links per Review Page",
        list: "List",
        list_unsubscribe_headers: "List-Unsubscribe Headers",
        load_more: "Load More",
        loading: "Loading",
        location: "Location",
        location_address: "Location Address",
        location_name: "Location Name",
        location_picker: "Location Picker",
        locations: "Locations",
        locations_limit: "Locations Limit",
        log_in: "Log In",
        log_out: "Log Out",
        logo: "Logo",
        logo_height: "Logo Height",
        long: "Long",
        lowest_rating: "Lowest Rating",
        ltd: "LTD",
        make_default: "Make Default",
        manage: "Manage",
        manage_limits: "Manage Limits",
        manage_overrides: "Manage Overrides",
        manage_payout_account: "Manage Payout Account",
        manage_subscription: "Manage Subscription",
        manual_entry: "Manual Entry",
        max: "Max",
        max_size: "Max Size",
        maximum_characters: "Maximum Characters",
        maximum_customers: "Maximum Customers",
        maximum_locations: "Maximum Locations",
        maximum_members: "Maximum Members",
        maximum_review_length: "Maximum Review Length",
        maximum_tags: "Maximum Tags",
        maximum_widgets: "Maximum Widgets",
        mcp: "MCP Server",
        mcp_server: "MCP Server",
        mcp_server_url: "MCP Server URL",
        medium: "Medium",
        member: "Member",
        members: "Members",
        menu: "Menu",
        message: "Message",
        message_link_expiration: "Message Link Expiration",
        messaged: "Messaged",
        messages: "Messages",
        messages_clicked: "Messages Clicked",
        messages_sent: "Messages Sent",
        messaging_service_sid: "Messaging Service SID",
        min: "Min",
        min_size: "Min Size",
        minimal_delay: "Minimal Delay",
        minimum_characters: "Minimum Characters",
        minutes: "Minutes",
        month: "month",
        monthly: "Monthly",
        monthly_email_requests: "Monthly Email Requests",
        monthly_limit: "Monthly Limit",
        monthly_pricing_only: "Monthly Pricing Only",
        monthly_request_limit: "Monthly Request Limit",
        monthly_requests: "Monthly Requests",
        monthly_sms_requests: "Monthly SMS Requests",
        months: "Months",
        months_free: "{count} Months Free",
        more: "more",
        more_clients: "more clients",
        more_customers: "more customers",
        more_options: "More Options",
        more_patients: "more patients",
        more_reviews: "more reviews",
        more_reviews_needed: "More reviews are needed to summarize",
        more_users: "more users",
        more_visitors: "more visitors",
        move: "Move",
        moved: "Moved",
        name: "Name",
        native_reviews: "Native Reviews",
        negative_term: "Negative Term",
        negative_trends: "Negative Trends",
        new: "New",
        new_password: "New Password",
        no: "No",
        no_available_options: "No available options",
        no_credit_card_required: "No credit card required",
        no_data_available: "No Data Available",
        no_negative_trends: "No negative trends yet",
        no_positive_trends: "No positive trends yet",
        no_reminders: "Don’t send reminders",
        no_retries: "No Retries",
        no_review: "No review",
        none: "None",
        not_connected: "Not Connected",
        not_reviewed: "Not Reviewed",
        notes: "Notes",
        notifications: "Notifications",
        now: "Now",
        number_of_charges: "Number of Charges",
        number_of_reminders: "Number of Reminders",
        number_of_retries: "Number of Retries",
        number_of_review_suggestions: "Number of Review Suggestions",
        of: "of",
        off: "Off",
        on: "On",
        on_channel: "on channel {channel}.",
        opened: "Opened",
        options: "Options",
        or_log_in_with_email: "or log in with your email address",
        or_sign_up_with_email: "or use your email address",
        our_reviews: "Our Reviews",
        output: "Output",
        page_footer: "Page Footer",
        paid: "Paid",
        paragraph: "Paragraph",
        password: "Password",
        past_month: "Past Month",
        past_months: "Past {inc} Months",
        past_week: "Past Week",
        past_year: "Past Year",
        past_years: "Past {inc} Years",
        paused: "Paused",
        payment_method: "Payment Method",
        payout_status_completed: "Completed",
        payout_status_pending: "Pending",
        pending: "Pending",
        pending_deployment: "Pending Deployment",
        pending_validation: "Pending Validation",
        per_day: "per day",
        per_month: "per month",
        permissions: "Permissions",
        phone: "Phone",
        phone_number: "Phone Number",
        pixels: "pixels",
        placeholder: "Placeholder",
        placement: "Placement",
        plan: "Plan",
        plan_bullet1: "Remove our branding on emails, pages, and widgets",
        plan_bullet2: "Use your domain for customer facing pages and email sending",
        plan_bullet3: "Make the product yours with white labeling for agencies",
        please_rate_our_service: "Please rate our service",
        png: "PNG",
        policies: "Policies",
        popular: "Popular",
        port: "Port",
        position: "Position",
        positive_only: "Positive Reviews Only",
        positive_term: "Positive Term",
        positive_trends: "Positive Trends",
        powered_by: "Powered by",
        preview: "Preview",
        preview_kiosk_page: "Preview Kiosk Page",
        preview_review_page: "Preview Review Page",
        price: "Price",
        pricing: "Pricing",
        primary_color: "Primary Color",
        priority: "Priority",
        privacy_policy: "Privacy Policy",
        proceed_to_dashboard: "Proceed to Dashboard",
        product: "Product",
        profile: "Profile",
        project: "Project",
        project_name: "Project Name",
        setup_ask_delay: "How long to wait before asking for a review",
        setup_reminders: "How many reminders to send",
        project_paused: "This project is paused.",
        project_suspended: "This project is suspended.",
        project_website: "Project Website",
        projects: "Projects",
        projects_limit: "Projects Limit",
        publish: "Publish",
        publish_changes: "Publish the changes to all other review pages",
        published: "Published",
        purchase: "Purchase",
        qr_code: "QR Code",
        qr_code_name_placeholder: "Table 1, Front desk",
        qr_codes: "QR Codes",
        quantity: "Quantity",
        query: "Query",
        quick_import: "Quick Import",
        rating: "Rating",
        rating_order: "Rating Order",
        rating_out_of: "rating out of",
        rating_save_all: "Save rating before every review",
        rating_save_customer: "Save rating before a customer review",
        rating_save_never: "Never save rating before review",
        rating_selection: "Rating Selection",
        rating_selector: "Rating Selector",
        ratings: "Ratings",
        read: "Read",
        reapply_highlights_eligible: "Regenerate highlights with AI for all positive reviews",
        reconnect: "Reconnect",
        redeem: "Redeem",
        redirect_uri: "Redirect URI",
        redirects: "Redirects",
        refer_and_earn: "Refer & Earn",
        referral_billing_status_active: "Subscribed",
        referral_billing_status_canceled: "Canceled",
        referral_billing_status_trial: "Trial",
        referral_billing_status_trial_expired: "Trial Expired",
        referral_billing_status_trial_expiring: "Trial Expiring",
        referral_program: "Referral Program",
        referral_program_terms: "Referral Program Terms",
        referrals: "Referrals",

        refresh: "Refresh",
        regenerate: "Regenerate",
        reject_all: "Reject All",
        related_reviews: "Similar Reviews",
        related_similarity: "Similarity",
        remaining: "Remaining",
        reminder: "Reminder",
        reminders: "Reminders",
        remove: "Remove",
        remove_client: "Remove Client",
        remove_cname: "Remove CNAME",
        remove_domain: "Remove Domain",
        remove_from_project: "Remove from Project",
        remove_member: "Remove Member",
        remove_smtp_configuration: "Remove SMTP Configuration",
        remove_team_member: "Remove Team Member",
        rename: "Rename",
        rename_template: "Rename Template",
        renews: "Renews",
        replied: "Replied",
        reply: "Reply",
        reply_to: "Reply To",
        replying_on: "Replying on",
        request: "Request",
        request_date: "Request Date",
        request_review: "Request a Review",
        request_reviews: "Request Reviews",
        requested: "Requested",
        requested_review: "Requested Review",
        requests: "Requests",
        requests_left_this_month: "requests left this month",
        requests_remaining: "Requests Remaining",
        require_field: "Require Field",
        require_subscription: "Customer must have an active subscription",
        required: "Required",
        reschedule_message: "Reschedule Message",
        resend_invite: "Resend Invite",
        reset_password: "Reset Password",
        restore: "Restore",
        restore_to_defaults: "Restore to Defaults",
        restore_widget: "Restore Widget",
        resubscribe: "Resubscribe",
        resubscribe_customer: "Resubscribe Customer",
        resync: "Re-Sync",
        resync_account: "Re-Sync Account",
        resync_now: "Re-Sync Now",
        retries: "Retries",
        reveal_above_form: "Reveal Above Form",
        reveal_after_submission: "Reveal After Submission",
        reveal_below_form: "Reveal Below Form",
        review: "Review",
        review_length: "Review Length",
        review_link: "Review Link",
        review_missed: "Review Missed",
        review_not_requested: "Review Not Requested",
        review_origin: "This review originated from template",
        review_page: "Review Page",
        review_pages: "Review Pages",
        review_requested: "Review Requested",
        review_spotlight: "Review Spotlight",
        review_suggestion: "Review Suggestion",
        review_suggestions: "Review Suggestions",
        review_text: "Review Text",
        review_wall: "Review Wall",
        reviewed: "Reviewed",
        reviews: "Reviews",
        reviews_ask: "Ask",
        reviews_query_failed: "Something went wrong. Please try again.",
        reviews_query_placeholder: "Search reviews or ask a question...",
        reviews_with_highlights: "Reviews with Highlights",
        reviews_with_replies: "Reviews with Replies",
        reviews_without_replies: "Reviews without Replies",
        revoke: "Revoke",
        revoke_client: "Revoke App",
        roadmap: "Roadmap",
        role: "Role",
        sans_serif: "Sans Serif",
        save: "Save",
        save_preferences: "Save Preferences",
        save_template: "Save Template",
        save_template_as_new: "Save New Template",
        saved: "Saved",
        schedule: "Schedule",
        schedule_review_request: "Schedule review request",
        scheduled: "Scheduled",
        score: "Score",
        search: "Search",
        second: "Second",
        secret_key: "Secret Key",
        sections: "Sections",
        security_code: "Security Code",
        select: "Select",
        select_account: "Select an Account",
        select_all: "Select All",
        select_an_option: "Select an option",
        select_bulk_action: "Select Bulk Action",
        select_csv_file: "Select CSV File",
        select_date: "Select Date",
        select_field: "Select a Field",
        select_icon: "Select an Icon",
        select_location: "Select a Location",
        select_plan: "Select a Plan",
        select_review: "Select a Review",
        select_source: "Select a Source",
        select_tag: "Select a Tag",
        selected: "Selected",
        send: "Send",
        send_1_reminder: "Send 1 reminder",
        send_2_reminders: "Send 2 reminders",
        send_3_reminders: "Send 3 reminders",
        send_anytime: "Send anytime",
        send_between: "Send between",
        send_message: "Send Message",
        send_retries: "Send {count} Retries",
        send_retry: "Send {count} Retry",
        send_test: "Send a Test",
        send_thanks: "Send thanks",
        sender_email_address: "Sender Email Address",
        sender_id: "Sender ID",
        sender_name: "Sender Name",
        sending_domain: "Sending Domain",
        sent: "Sent",
        sent_replies: "Sent Replies",
        serif: "Serif",
        settings: "Settings",
        share: "Share",
        share_link: "Share Link",
        short: "Short",
        show: "Show",
        show_1_suggestion: "Show One Suggestion",
        show_100_results: "Show 100 Results",
        show_2_suggestions: "Show Two Suggestions",
        show_25_results: "Show 25 Results",
        show_3_suggestions: "Show Three Suggestions",
        show_4_suggestions: "Show Four Suggestions",
        show_5_suggestions: "Show Five Suggestions",
        show_50_results: "Show 50 Results",
        show_all_reviews: "Show all reviews",
        show_arrows: "Show Arrows",
        show_avatar: "Show Avatar",
        show_cookie_consent_banner: "Show cookie consent banner",
        show_date: "Show Date",
        show_dots: "Show Dots",
        show_drop_shadow: "Show Drop Shadow",
        show_field: "Show field on the following ratings",
        show_full: "Show Full Stars",
        show_photo: "Show Photo Only",
        show_positive_reviews: "Show only positive reviews",
        show_to_public: "Show to Public",
        showcase: "Showcase",
        showcase_page: "Showcase Page",
        sign_up: "Sign Up",
        sign_up_for_free: "Sign Up for Free",
        sign_up_with_email: "Sign Up with Email",
        sign_in_with_sso: "Sign in with SSO",
        sign_up_with_google: "Sign Up with Google",
        signature: "Signature",
        signatures: "Signatures",
        signed_up: "Signed Up",
        since: "Since",
        size: "Size",
        skip: "Skip",
        slug: "Slug",
        small: "Small",
        sms: "SMS",
        smtp_configuration: "SMTP Configuration",
        sort: "Sort",
        source: "Source",
        source_code: "Source Code",
        sources: "Sources",
        space: "Space",
        space_name: "Space Name",
        spaces: "Spaces",
        split: "Split",
        sso: "SSO",
        star_color: "Star Color",
        stars: "Stars",
        start: "Start",
        start_free_trial: "Start Free Trial",
        start_getting_more_reviews: "Start Getting More Reviews",
        status: "Status",
        store_code: "Store Code",
        strategy: "Strategy",
        sub_processors: "Sub-processors",
        subject: "Subject",
        subscribe: "Subscribe",
        subscription: "Subscription",
        success_page: "Success Page",
        suggestion: "Suggestion",
        suggestions: "Suggestions",
        summary: "Summary",
        support: "Support",
        suspend: "Suspend",
        suspend_project: "Suspend Project",
        suspended: "Suspended",
        svg: "SVG",
        switch_to_smtp_setup: "Switch to SMTP Setup",
        switch_to_standard_setup: "Switch to Standard Setup",
        symbol: "Symbol",
        sync: "Sync",
        sync_account: "Sync Account",
        sync_now: "Sync Now",
        sync_scheduled_time: "Sync scheduled {time}",
        synced_time: "Synced {time}",
        system: "System",
        system_fonts: "System Fonts",
        tag: "Tag",
        tag_1_customer: "Tag 1 Customer",
        tag_1_review: "Tag 1 Review",
        tag_customers: "Tag Customers",
        tag_existing_reviews: "Tag Existing Reviews",
        tag_n_customers: "Tag {count} Customers",
        tag_n_reviews: "Tag {count} Reviews",
        tag_reviews: "Tag Reviews",
        tag_rule: "Tag Rule",
        tag_with_ai: "Tag with AI",
        tags: "Tags",
        tags_for_customers: "Tags for Customers",
        tags_for_reviews: "Tags for Reviews",
        team: "Team",
        team_member: "Team Member",
        team_members: "Team Members",
        template: "Template",
        templates: "Templates",
        terms_of_service: "Terms of Service",
        test_template: "Test template",
        tests: "Tests",
        text: "Text",
        text_alignment: "Text Alignment",
        text_color: "Text Color",
        thank_you_messages: "Thank You Messages",
        thanks: "Thanks",
        theme: "Theme",
        third: "Third",
        time_zone: "Time Zone",
        timeframe: "Timeframe",
        title: "Title",
        tone: "Tone",
        top: "Top",
        top_left: "Top Left",
        top_right: "Top Right",
        total_charges: "Total Charges",
        total_reviews: "Total Reviews",
        trigger: "Trigger",
        trigger_charged: "Send request after a charge",
        trigger_created: "Send request after signup",
        try_free: "Try Free",
        try_it_free: "Try It Free",
        type: "Type",
        types: "Types",
        unarchive: "Unarchive",
        unarchive_customer: "Unarchive Customer",
        underline: "Underline",
        unflag_as_duplicate: "Unflag as Duplicate",
        unknown: "Unknown",
        unnamed: "Unnamed",
        unpublish: "Unpublish",
        unpublished: "Unpublished",
        unreplied: "Unreplied",
        unsent_messages: "Unsent Messages",
        unsubscribe: "Unsubscribe",
        unsubscribe_customer: "Unsubscribe Customer",
        unsubscribe_customers: "Unsubscribe Customers",
        unsubscribe_text: "Unsubscribe Text",
        unsubscribed: "Unsubscribed",
        unsuspend: "Unsuspend",
        unsuspend_project: "Unsuspend Project",
        unverified: "Unverified",
        update: "Update",
        update_password: "Update Password",
        update_plan: "Update Plan",
        update_share_template: "Update Template",
        updated: "Updated",
        updates: "Updates",
        upgrade: "Upgrade",
        upgrade_for_more: "Upgrade for more",
        upgrade_to_use: "Please upgrade to use this feature",
        upload: "Upload",
        upload_csv: "Upload CSV",
        upload_icon: "Upload an Icon",
        url: "URL",
        use: "Use",
        use_filters_for_aggregate: "Use Filters for Aggregate",
        user: "User",
        user_id: "User ID",
        user_info: "User Info",
        username: "Username",
        utc: "UTC",
        validate: "Validate",
        validate_customer_email: "Validate Customer Email",
        validation: "Validation",
        validations: "Validations",
        value: "Value",
        verify: "Verify",
        verify_email_address: "Verify Email Address",
        view: "View",
        view_all: "View All",
        view_all_features: "View All Features",
        view_available_fields: "View Available Fields",
        view_documentation: "View Documentation",
        view_email_templates: "View Email Templates",
        view_review_pages: "View Review Pages",
        view_reviews: "View Reviews",
        view_settings: "View Settings",
        view_setup_guide: "View Setup Guide",
        view_showcase: "View Showcase",
        view_strategy: "View Strategy",
        visibility: "Visibility",
        visible: "Visible",
        visible_reviews: "Visible Reviews",
        visible_to_search_engines: "Visible to Search Engines",
        wait_between_reminders: "Wait between reminders",
        wait_period: "Wait Period",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Website",
        weekly: "Weekly",
        weeks: "Weeks",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "with AI",
        worst_to_best: "Worst to best",
        write: "Write",
        written_reviews: "Written Reviews",
        year: "year",
        yearly: "Yearly",
        yes: "Yes",
        your_referral_link: "Your Referral Link",
    },
    landing: {
        announcement: "Get reputation reports in Claude",
        counter: "Join 5,000+ local service businesses",
        feature_1_subtitle: "Automatically ask your customers for reviews — no extra work needed.",
        feature_1_title: "Improve Your Reputation",
        feature_2_subtitle: "Easily add your existing 3rd party reviews.",
        feature_2_title: "Import Your Reviews",
        feature_3_subtitle: "Easily display reviews on your website with fully customizable widgets.",
        feature_3_title: "Showcase Reviews Anywhere",
        feature_4_subtitle: "Personalize your email and SMS requests and reminders to match your brand.",
        feature_4_title: "Customizable Templates",
        feature_5_subtitle: "Set it once and let us handle when review requests and reminders are sent.",
        feature_5_title: "Smart Request Scheduling",
        feature_6_subtitle: "Collect 3rd party reviews or gather private feedback — all on your own custom page.",
        feature_6_title: "Personalized Review Page",
        feature_7_subtitle: "Make it easier for customers to leave good reviews with AI-powered review suggestions.",
        feature_7_title: "AI Review Suggestions",
        feature_8_subtitle: "Redirect customers to all your review sites from one link or QR code.",
        feature_8_title: "Collect Reviews Everywhere",
        industries: {
            accountants: "Accountants",
            auto_repair: "Auto Mechanics",
            chiropractors: "Chiropractors",
            cleaning: "Cleaners",
            contractors: "Contractors",
            dentists: "Dentists",
            doctors: "Doctors",
            electricians: "Electricians",
            financial_advisors: "Financial Advisors",
            hvac: "HVAC Technicians",
            insurance_brokers: "Insurance Brokers",
            landscapers: "Landscapers",
            law_firms: "Lawyers",
            locksmiths: "Locksmiths",
            mortgage_brokers: "Mortgage Brokers",
            optometrists: "Optometrists",
            personal_trainers: "Personal Trainers",
            pest_control: "Exterminators",
            physical_therapists: "Physical Therapists",
            plumbers: "Plumbers",
            real_estate: "Real Estate Agents",
            restaurants: "Restaurant Owners",
            salons: "Hair Stylists",
            self_storage: "Storage Operators",
            spas: "Estheticians",
            tour_guides: "Tour Guides",
            veterinarians: "Veterinarians",
        },
        industries_title: "Review management for local service businesses",
        stat_1_article: "Consumer Research Report",
        stat_1_desc: "People want more than 100 reviews before they trust a business online.",
        stat_1_source: "Salsify",
        stat_1_title: "Reviews Earn Trust",
        stat_2_article: "Marketing Science",
        stat_2_desc: "When you answer reviews, more customers leave new ones.",
        stat_2_source: "Proserpio & Zervas",
        stat_2_title: "From Replies",
        stat_3_article: "Reviews, Reputation, and Revenue",
        stat_3_desc: "A small rating bump can mean a real lift in what you earn.",
        stat_3_source: "Harvard Business School",
        stat_3_title: "Revenue Per Star",
        stat_4_article: "Consumer Reliance on AI Search Results",
        stat_4_desc: "When people ask AI who to choose, your reviews help write the answer.",
        stat_4_source: "Bain & Company",
        stat_4_title: "of People Ask AI",
        subtitle: "Request reviews on autopilot. Get more 5-star ratings. Rank higher than your competition.",
        subtitle_feature_summary: "Collection, display, AI, and integrations — ready when you are.",
        summary_10_desc: "Organize customers and reviews so you can filter and act fast.",
        summary_10_title: "Customer & review tagging",
        summary_11_desc: "Zapier hooks More Good Reviews into the tools you already use.",
        summary_11_title: "Connect to any app",
        summary_12_desc: "Manage reputation from Claude, ChatGPT, and other MCP clients.",
        summary_12_title: "MCP for AI assistants",
        summary_1_desc: "Scheduled email and SMS outreach with reminders, on autopilot.",
        summary_1_title: "Automatic review requests",
        summary_2_desc: "Email and SMS that match your brand, voice, and offer.",
        summary_2_title: "Branded templates",
        summary_3_desc: "Collect private feedback or send people to Google, Facebook, and more.",
        summary_3_title: "Review pages",
        summary_4_desc: "Printable codes and full-screen in-store collection.",
        summary_4_title: "QR codes & kiosk",
        summary_5_desc: "Embed ratings and reviews anywhere on your website.",
        summary_5_title: "Website widgets",
        summary_6_desc: "A public, brandable page for your best reviews.",
        summary_6_title: "Showcase page",
        summary_7_desc: "Import reviews and reply from one place.",
        summary_7_title: "Google & Facebook sync",
        summary_8_desc: "On-page suggestions that help customers leave a review.",
        summary_8_title: "AI review writing help",
        summary_9_desc: "Draft replies, summaries, trends, and Ask AI on your reviews.",
        summary_9_title: "AI replies & insights",
        title: "AI reputation management to",
        title_contact: "How can we help?",
        title_faq: "Common Questions",
        title_feature_summary: "Everything in the box",
        title_features: "The all-in-one toolkit to request and showcase reviews",
        title_footer: "Stop chasing reviews. Start getting them.",
        title_integrations: "Integrations",
        title_ltd: "Pay once and use forever with our limited time lifetime deal",
        title_phrases: {
            autopilot: "request reviews on autopilot",
            google_reviews: "get more Google reviews",
            suggested_by_chatgpt: "get suggested by ChatGPT",
        },
        title_pricing: "Every feature. Simple pricing.",
        title_reviews: "See why we’re rated #1 in review management",
    },
    plans: {
        agency: {
            agency_api: "Agency API",
            branded_portal: "Branded client portal",
            client_invites: "Client invites, roles & overrides",
            custom_domain: "Custom agency domain",
            everything_in_business: "Everything in Business plan",
            locations_included: "5 locations included",
            review_requests: "5,000 review requests / location / month",
            sso: "Single sign-on (SSO)",
            support: "Dedicated customer support",
            volume_pricing: "Volume pricing from $49/mo",
        },
        business: {
            ai: "AI replies, insights & Ask AI",
            api_mcp: "API and MCP Server",
            custom_domains: "Custom email and review page domains",
            google_facebook: "Google Business Profile & Facebook",
            locations_included: "1 location included",
            review_requests: "{count} review requests / location / month",
            support: "Dedicated customer support",
            unlimited_customers: "Unlimited customers",
            volume_pricing: "Volume pricing from $99/mo",
        },
        selectors: {
            agency_included: "{count} Locations Included",
            agency_tier: "+{from}–{to} locations · {price}/{month} each",
            agency_tier_plus: "+{from}+ locations · {price}/{month} each",
            business_tier: "{from}–{to} locations · {price}/{month} each",
            business_tier_plus: "{from}+ locations · {price}/{month} each",
        },
    },
    pricing: {
        faq_business_vs_agency_a: "Business is for companies managing their own reputation—priced per location, with monthly or yearly billing. Agency is for agencies and consultants who need a white-label client portal, custom agency domain, client SSO, client invites, and per-project overrides. Agency is monthly only and includes 5 locations to start.",
        faq_business_vs_agency_q: "What’s the difference between Business and Agency?",
        feature_sso_tooltip: "Let invited clients sign in to your portal with their company identity provider via OpenID Connect (for example Auth0, Okta, or Azure AD).",
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Add a customer and request a review",
            customers_to_ask: "Find customers to ask for reviews",
            location_leaderboard: "Compare location performance",
            outreach_health: "Audit outreach delivery health",
            review_digest: "Weekly review digest",
            send_review_requests: "Send review requests in bulk",
        },
        texts: {
            add_customer_and_ask: "Add a new customer using the contact details I give you, then schedule a review request for them via email with 2 reminders.",
            customers_to_ask: "List up to 50 customers who have never been asked for a review, sorted by signup date with the newest first. Skip anyone unsubscribed. Include name, email, and signup date.",
            location_leaderboard: "Build a 90-day leaderboard by location with review count, average rating, percent 5-star, and trend vs the prior 90 days. Sort by rating and flag any drop over 0.2 stars.",
            outreach_health: "For email messages sent in the past 14 days, report total sent, delivery rate, open rate, click rate, and failure rate. Flag any anomalies.",
            review_digest: "Summarize all reviews from the past 7 days. Include count, average rating, breakdown by source and location, top 3 themes, and top 3 concerns.",
            send_review_requests: "For customers who signed up in the past 30 days and haven't been asked, schedule a review request via email with 2 reminders. Show the list first and wait for my confirmation.",
        },
    },
    messages: {
        activated: "Successfully activated.",
        archived: "Successfully archived.",
        canceled: "Successfully canceled.",
        cannot_copy: "Unable to copy to clipboard",
        cname_active: "CNAME status is active.",
        cname_not_active: "CNAME status is not yet active.",
        connected: "Successfully connected.",
        cookie_banner_text: "We use cookies to improve your experience. You can customize your preferences or accept all.",
        cookie_category_analytics_desc: "Used to measure website traffic and product usage. These cookies help us understand how visitors use our site.",
        cookie_category_essential_desc: "Always active. These cookies are required for the site to function and cannot be turned off.",
        cookie_category_functional_desc: "Enable enhanced features like live chat. These cookies do not track you for advertising purposes.",
        cookie_category_marketing_desc: "Used for advertising and campaign measurement. These may include ad pixels and attribution tools.",
        copied: "Successfully copied.",
        created: "Successfully created.",
        deactivated: "Successfully deactivated.",
        deleted: "Successfully deleted.",
        disconnected: "Successfully disconnected.",
        duplicated: "Successfully duplicated.",
        error: "Something went wrong. Please try again.",
        google_connect_failed: "We couldn’t connect to Google. You can try again or skip for now.",
        oauth_consent_intro: "{client} is requesting permission to access your account.",
        oauth_request_missing: "The OAuth authorization request is missing or expired.",
        operation_connection_sync_failed: "{integration_name} sync failed.",
        operation_connection_sync_progress: "Syncing {integration_name}…",
        operation_connection_sync_success: "{integration_name} sync complete.",
        operation_customer_import_failed: "Customer import failed.",
        operation_customer_import_progress: "Importing customers…",
        operation_customer_import_success: "Customer import complete.",
        operation_review_import_failed: "Review import failed.",
        operation_review_import_progress: "Importing reviews…",
        operation_review_import_success: "Review import complete.",
        operation_review_scrape_failed: "Recent review import failed.",
        operation_review_scrape_progress: "Importing recent reviews…",
        operation_review_scrape_success: "Recent review import complete.",
        processed: "Successfully processed.",
        published: "Successfully published.",
        purchased: "Successfully purchased.",
        queued: "Successfully scheduled.",
        refreshed: "Successfully refreshed.",
        removed: "Successfully removed.",
        resubscribed: "Successfully resubscribed.",
        revoked: "Successfully revoked.",
        saved: "Successfully saved.",
        scheduled: "Successfully scheduled.",
        sent: "Successfully sent.",
        started: "Successfully started.",
        stopped: "Successfully stopped.",
        sso_failed: "Unable to authorize with SSO.",
        sso_invalid_callback: "Invalid SSO callback.",
        sso_not_configured: "SSO is not configured.",
        sso_openid_config_failed: "Unable to load OpenID configuration.",
        sso_token_exchange_failed: "Unable to complete SSO token exchange.",
        subscribed: "Successfully subscribed.",
        suspended: "Successfully suspended.",
        synced: "Successfully synced.",
        unarchived: "Successfully unarchived.",
        unpublished: "Successfully unpublished.",
        unscheduled: "Successfully unscheduled.",
        unsubscribed: "Successfully unsubscribed.",
        unsuspended: "Successfully unsuspended.",
        updated: "Successfully updated.",
        upgraded: "Successfully upgraded.",
        validated: "Successfully validated.",
        verified: "Successfully verified.",
    },
    notices: {
        agency: "Running an agency? You can white label our product so your customers only see your brand when using the service.",
        connected_apps: "Apps you connect through MCP will appear here.",
        connector: "Import your customers from thousands of applications with {brand}.",
        customer_messages: "Request a review to schedule messages.",
        customer_reviews: "Request a review from this customer.",
        customers: "Import your customers to start requesting reviews.",
        external_links: "Add external links to your customer portal to help sell your services. These links will be shown to your customers in the sidebar.",
        links: "Add buttons to your page to leave reviews on 3rd party websites.",
        locations: "Create a location so you can attribute reviews to multiple locations.",
        ltd: "Unlock lifetime access with your access code. Each code comes with a limited amount of monthly requests, plus all features. Codes are stackable. 3 codes removes all of our branding and unlocks agency features. Enter your access code below.",
        mcp_example_prompts: "Once the MCP server is connected, paste these into your assistant as a starting point.",
        messages: "Every request and reminder will show up here when reviews are requested from your customers.",
        no_commissions: "You have not earned any commissions yet.",
        no_payouts: "Payouts are sent manually once your approved balance reaches at least $50.00 and your bank account is connected.",
        no_projects: "You have not been assigned to a project yet. Contact your administrator to get access.",
        no_referrals: "You have not referred anyone yet. Share your referral link to get started.",
        qr_codes: "Create QR codes with custom colors, locations, and tags. Download as SVG or PNG.",
        referrals_share_subject: "My AI Reputation Manager",
        referrals_share_text: "My secret weapon for getting business reviews: More Good Reviews. AI reputation management that actually works. Sign up with my link:",
        review_pages: "Your project can have multiple review pages for your customers to leave reviews. This is useful for businesses with more than one location.",
        reviews: "We’re waiting for reviews from your customers.",
        showcase: "We’re just getting started.",
        signatures: "Create a signature to copy and paste into your email application.",
        sources: "Create a source so you can categorize your reviews.",
        tag_rules: "Create a rule to categorize your reviews automatically with AI.",
        tags: "Create a tag to categorize your reviews and customers.",
        unauthorized: "You do not have permission to access this page.",
        unsubscribed: "You are now unsubscribed from review requests.",
        webhooks: "Add webhooks to get notified about platform events.",
        widgets: "Create widgets to embed reviews on your website.",
        your_referral_link_text: "Share your link to earn {rate}% recurring commission on every payment from customers you refer. Payouts are sent manually once your approved balance reaches at least $50.00.",
    },
    notification_types: {
        descriptions: {
            imports: "Sent when imports are completed",
            new_reviews: "Sent when reviews are received",
            sent_replies: "Sent when reviews are automatically replied to",
            weekly_reports: "A summary of activity sent weekly",
        },
        names: {
            imports: "Imports",
            new_reviews: "New Reviews",
            sent_replies: "Sent Replies",
            weekly_reports: "Weekly Reports",
        },
    },
    roles: {
        manager: "Manager",
        operator: "Operator",
        owner: "Owner",
        super_admin: "Admin",
        viewer: "Viewer",
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding.",
    },
    titles: {
        accept_invite: "Accept Invite",
        accepting_invite: "Accepting Invite",
        access_denied: "Access Denied",
        account: "Account",
        actions: "Actions",
        add_custom_field: "Add Custom Field",
        add_ons: "Add-Ons",
        address: "Address",
        agency: "Agency",
        ai_assistant: "AI Assistant",
        ai_highlights: "AI Highlights",
        ai_replies: "AI Replies",
        ai_review_suggestions: "AI Review Suggestions",
        analytics: "Analytics",
        api: "API",
        api_key: "API Key",
        appearance: "Appearance",
        application_connectors: "Application Connectors",
        attributes: "Attributes",
        authorize: "Authorize",
        auto_tagging: "Auto Tagging",
        automatic_review_collection: "Automatic Review Collection",
        billing: "Billing",
        branding: "Branding",
        change_password: "Change Password",
        clients: "Clients",
        cname: "CNAME",
        conditions: "Conditions",
        connected_apps: "Connected Apps",
        contact_us: "Contact Us",
        cookie_policy: "Cookie Policy",
        cookie_preferences: "Cookie Preferences",
        copy: "Copy",
        create_your_account: "Create Your Account",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Custom Field",
        custom_fields: "Custom Fields",
        custom_icons: "Custom Icons",
        customer: "Customer",
        customer_facing_pages: "Customer Facing Pages",
        customers: "Customers",
        dashboard: "Dashboard",
        details: "Details",
        dmarc: "DMARC",
        domain: "Domain",
        dpa: "Data Processing Agreement",
        dsar: "Data Subject Access Request",
        email_address: "Email Address",

        email_messages: "Email Messages",
        email_settings: "Email Settings",
        email_usage: "Email Usage",
        emails: "Emails",
        embed_code: "Embed Code",
        examples: "Examples",
        export: "Export",
        external_link: "External Link",
        external_link_num: "External Link #{num}",
        external_links: "External Links",
        field: "Field",
        fields: "Fields",
        filters: "Filters",
        form_fields: "Form Fields",
        got_access_code: "Got an Access Code?",
        hipaa: "HIPAA Statement",
        how_it_works: "How It Works",
        incentive: "Incentive",
        instructions: "Instructions",

        integration: "Integration",
        integrations: "Integrations",
        javascript: "JavaScript",
        latest_reviews: "Latest Reviews",
        lifetime_deal: "Lifetime Deal",
        limits: "Limits",
        link: "Link",
        links: "Links",
        location: "Location",
        location_picker: "Location Picker",
        locations: "Locations",
        log_in: "Log In",
        log_out: "Log Out",
        make_default: "Make Default",
        manage_limits: "Manage Limits",
        manage_overrides: "Manage Overrides",
        manage_review: "Manage Review",
        mcp_example_prompts: "Example Prompts",
        mcp_server: "MCP Server",
        message: "Message",
        messages: "Messages",
        meta: "Meta",
        no_clients: "No Clients",
        no_commissions: "No Commissions",
        no_connected_apps: "No Connected Apps",
        no_custom_fields: "No Custom Fields",
        no_customers: "No Customers",
        no_links: "No Links",
        no_locations: "No Locations",
        no_members: "No Members",
        no_messages: "No Messages",
        no_payouts: "No Payouts",
        no_projects: "No Projects",
        no_qr_codes: "No QR Codes",
        no_referrals: "No Referrals",
        no_review_pages: "No Review Pages",
        no_reviews: "No Reviews",
        no_tags: "No Tags",
        no_team_members: "No Team Members",
        no_template: "No Template",
        no_widgets: "No Widgets",
        notifications: "Notifications",
        options: "Options",
        overview: "Overview",
        payment_method: "Payment Method",
        photo: "Photo",
        plans: "Plans",
        powered_by: "Powered by",
        pricing: "Pricing",
        privacy_policy: "Privacy Policy",
        profile: "Profile",
        project: "Project",
        project_limits: "Project Limits",
        project_overrides: "Project Overrides",
        projects: "Projects",
        qr_code: "QR Code",
        qr_codes: "QR Codes",
        ratings: "Ratings",
        redeem_access_code: "Redeem Access Code",
        redirecting: "Redirecting",
        redirects: "Redirects",
        referrals_commissions: "Commissions",
        referrals_payouts: "Payouts",
        referral_program: "Referral Program Terms",
        reminders: "Reminders",
        reply: "Reply",
        request: "Request",
        request_options: "Request Options",
        requests: "Requests",
        required: "Required",
        reschedule_message: "Reschedule Message",
        reset_password: "Reset Password",
        retries: "Retries",
        review: "Review",
        review_link: "Review Link",
        review_page: "Review Page",
        review_pages: "Review Pages",
        review_spotlight: "Review Spotlight",
        review_suggestions: "Review Suggestions",
        review_wall: "Review Wall",
        reviewer: "Reviewer",
        reviews: "Reviews",
        save_changes: "Save Changes",
        schedule: "Schedule",
        scrape_a_website: "Scrape a Website",
        search_engines: "Search Engines",
        sections: "Sections",
        select_csv_file: "Select CSV File",
        select_project: "Select a Project",
        selecting_project: "Selecting Project",
        sending_domain: "Sending Domain",
        sending_limits: "Sending Limits",
        settings: "Settings",
        setup: "Setup",
        setup_basics: "Your Request Strategy",
        setup_business: "Let’s Get Started",
        setup_google: "Your Google Business Profile",
        setup_trusted: "Trusted by 5,000+ Businesses",
        showcase: "Showcase",
        sign_up: "Sign Up",
        signature: "Signature",
        signatures: "Signatures",
        signing_in: "Signing in",
        single_sign_on: "Single sign-on",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS Messages",
        sms_usage: "SMS Usage",
        smtp_configuration: "SMTP Configuration",
        source: "Source",
        sources: "Sources",
        space: "Space",
        spaces: "Spaces",
        stats: "Stats",
        sub_processors: "Sub-processors",
        success_page: "Success Page",
        summary: "Summary",
        tag: "Tag",
        tag_rule: "Tag Rule",
        tags: "Tags",
        team_members: "Team Members",
        template: "Template",
        templates: "Templates",
        terms_of_service: "Terms of Service",
        two_factor_authentication: "Two-Factor Authentication",
        unable_to_complete_request: "Unable to Complete Request",
        unique_review_link: "Unique Review Link",
        unsent_messages: "Unsent Messages",
        unsubscribe: "Unsubscribe",
        update_plan: "Update Plan",
        usage: "Usage",
        user: "User",
        user_info: "User Info",
        verify_email_address: "Verify Email Address",
        verifying_email: "Verifying Email",
        visibility: "Visibility",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Website",
        white_label_api: "White Label API",
        white_label_client_portal: "White Label Client Portal",
        white_label_image_urls: "White Label Image URLs",
        white_label_sending_domain: "White Label Sending Domain",
        white_label_widget_tag: "White Label Widget Tag",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "Your Plan",
    },
    tones: {
        apologetic: "Apologetic",
        casual: "Casual",
        empathetic: "Empathetic",
        enthusiastic: "Enthusiastic",
        formal: "Formal",
        friendly: "Friendly",
        grateful: "Grateful",
        humorous: "Humorous",
        informative: "Informative",
    },
    widgets: {
        labels: {
            alignment: "Alignment",
            animation: "Animation",
            autoplay: "Autoplay",
            autoplay_delay: "Autoplay Delay",
            avatar: "Avatar",
            background_color: "Background Color",
            border: "Border",
            border_color: "Border Color",
            border_radius: "Border Radius",
            border_width: "Border Width",
            carousel: "Carousel",
            colors: "Colors",
            company: "Company",
            customer: "Customer",
            customer_position: "Customer Position",
            date: "Date",
            delay: "Delay",
            drop_shadow: "Drop Shadow",
            duration: "Duration",
            filters: "Filters",
            font: "Font",
            font_emphasis: "Font Emphasis",
            font_family: "Font Family",
            font_size: "Font Size",
            include_hidden: "Include Hidden Reviews",
            layout: "Layout",
            limit: "Reviews Per Page",
            location_ids: "Locations",
            marquee: "Marquee",
            max_slides: "Max Slides",
            max_width: "Max Width",
            name_convention: "Name",
            padding: "Padding",
            pagination: "Pagination",
            quotes: "Quotes",
            rating: "Rating",
            rating_round: "Rounding",
            rating_round_hundredth: "Nearest hundredth (4.94)",
            rating_round_tenth: "Nearest tenth (4.9)",
            review: "Review",
            review_chars: "Review Length",
            review_count: "Review Count",
            review_id: "Review",
            review_ids: "Reviews",
            review_ids_for_faces: "Reviews for Faces",
            reviews: "Reviews",
            schema: "Schema",
            schema_name: "Business Name",
            schema_type: "Business Type",
            score: "Lowest Rating",
            show_on_mobile: "Show on Mobile",
            slider: "Slider",
            source: "Source",
            source_ids: "Sources",
            source_position: "Source Position",
            speed: "Speed",
            star_color: "Star Color",
            star_display: "Star Display",
            star_size: "Star Size",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Tags",
            take: "Maximum Number of Reviews",
            text_color: "Text Color",
            truncate: "Shorten Review",
            visible_slides: "Visible Slides",
            width: "Width",
        },
        types: {
            badge: "Badge",
            carousel: "Carousel",
            carousel_dynamic: "Dynamic Carousel",
            corner: "Corner",
            corner_dynamic: "Dynamic Corner",
            faces: "Faces",
            headline: "Headline",
            highlights: "Highlights",
            marquee: "Marquee",
            spotlight: "Spotlight",
            wall: "Wall",
        },
    },
}
